import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestCookiesOrderPut = {
    path: "/cookies/order",
    method: RouteHttpVerb.PUT
};
export { locationRestCookiesOrderPut };
